const centerImages = () => {
  const images = document.querySelectorAll('.article-template__content > p > img');
  images.forEach(img => {
    img.parentNode.classList.add('center');
  });
}

window.addEventListener('load', function() {
  centerImages();

  const newParentElement = document.querySelector('#PositionedSlider');
  const rawCarouselParentElement = document.querySelector('#ArticleCarousel');

  if(newParentElement && rawCarouselParentElement) {
    const newNode = newParentElement.parentNode.replaceChild(rawCarouselParentElement, newParentElement);

    const thumbsSlider = new Swiper("#ArticleCarousel .thumbsSlider", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
          // when window width is >= 751px
          751: {
              slidesPerView: 4,
              spaceBetween: 15,
          },
      }
    });
    
    const mainSlider = new Swiper("#ArticleCarousel .mainSlider", {
        spaceBetween: 10,
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: thumbsSlider,
        },
    });
  }


});